import { render, staticRenderFns } from "./ConfigurationItems.vue?vue&type=template&id=67d068f4&"
import script from "./ConfigurationItems.vue?vue&type=script&lang=js&"
export * from "./ConfigurationItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports